import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { DocumentEditorModule } from '@txtextcontrol/tx-ng-document-editor';
import { DocumentViewerModule } from '@txtextcontrol/tx-ng-document-viewer';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
// Authentication Services
import { AuthenticationService } from './_services/authentication.service';
import { GlobalFunctionsService } from './services/global-functions.service';
import { MysqlService } from './services/mysql.service';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { DemoService } from './demo.service';
import { JwtInterceptor } from './_helpers/index';




import { ClientGuard } from './_guards/client.guard';
import { StaffGuard } from './_guards/staff.guard';
import { ManagerGuard } from './_guards/manager.guard';
import { AgentGuard } from './_guards/agent.guard';

import { StaffComponent } from './staff/staff.component';
import { ClientComponent } from './client/client.component';
// import { ManagerComponent } from './manager/manager.component';

import { AdminGuard, AuthGuard } from './_guards/index';
import { LayoutsModule } from './components/common/layouts/layouts.module';
import { IdleService } from './services/idle.service';
import { AdminComponent } from './admin/admin.component';
import { TxcPrototypeComponent } from './admin/txc/txc-prototype/txc-prototype.component';
import { LogoutComponent } from './logout/logout.component';
import { ExampleTextControlComponent } from './example-text-control/example-text-control.component';
import { JobsHomeComponent } from './admin/jobs/jobs-home/jobs-home.component';
import { RouterModule, Routes } from '@angular/router';


import { ButtonModule, CheckBoxAllModule, CheckBoxModule, ChipListModule, RadioButtonModule } from '@syncfusion/ej2-angular-buttons';
import { GridModule, FreezeService, SelectionService, PdfExportService, ExcelExportService, GridAllModule, EditService } from '@syncfusion/ej2-angular-grids';
import { MenuModule, TreeViewModule} from '@syncfusion/ej2-angular-navigations';
import { PageService, SortService, FilterService, GroupService, ToolbarService, ResizeService   } from '@syncfusion/ej2-angular-grids';
import { AccordionModule, AlertModule, BsDropdownModule, SortableModule, TabsetComponent} from 'ngx-bootstrap';
import { BsModalRef, BsModalService, ModalModule} from 'ngx-bootstrap/modal';
import { BsDatepickerModule, DatePickerComponent } from 'ngx-bootstrap/datepicker';
import { PaginationModule } from 'ngx-bootstrap';
import { TabsModule } from 'ngx-bootstrap';
import { DatePipe, DecimalPipe, HashLocationStrategy, LocationStrategy, NgTemplateOutlet } from '@angular/common';

// import {routes} from './app-routing.module';
import { TxcSimpleNavComponent } from './admin/txc/txc-simple-nav/txc-simple-nav.component';
import { CommunicationComponent } from './communication/communication.component';
import { HtmlEditorService, ImageService, LinkService, RichTextEditorModule } from '@syncfusion/ej2-angular-richtexteditor';
import { AutoCompleteModule, ComboBoxModule, DropDownListComponent, DropDownListModule, ListBoxAllModule, ListBoxModule, MultiSelectComponent, MultiSelectModule } from '@syncfusion/ej2-angular-dropdowns';
import {routes} from './app-routing.module';
import { JobsDashboardComponent } from './admin/jobs/jobs-dashboard/jobs-dashboard.component';
import { SearchService } from './services/search.service';
import { IboxtoolsModule } from './components/common/iboxtools/iboxtools.module';
import { JobSubjectSearchWidgetComponent } from './admin/jobs/job-subject-search-widget/job-subject-search-widget.component';
import { JobsComponent } from './admin/jobs/jobs.component';
import { JobsGridComponent } from './components/grid/jobs-grid/jobs-grid.component';
import { DatePickerModule, DateTimePickerAllModule } from '@syncfusion/ej2-angular-calendars';
import { DialogModule } from '@syncfusion/ej2-angular-popups';
import { JobViewComponent } from './admin/jobs/job-view/job-view.component';

import { FileUploaderService } from './services/file-uploader-service';
import { JobDetailsWidgetComponent } from './components/jobs/job-details-widget/job-details-widget.component';
import { JobSubjectDocumentAddWidgetComponent } from './components/jobs/job-subject-document-add-widget/job-subject-document-add-widget.component';
import { JobsFileGridComponent } from './components/grid/jobs-file-grid/jobs-file-grid.component';
import { DateAgoPipe } from './pipes/date-ago.pipe';
import { AuditDatePipe } from './pipes/audit-date.pipe';
import { AuditDateAgoPipe } from './pipes/audit-date-ago.pipe';
import { AuditDateComparePipe } from './pipes/audit-date-compare.pipe';
import { LegalDatePipe } from './pipes/legal-date.pipe';
import { LegalDateComparePipe } from './pipes/legal-date-compare.pipe';
import { AssignSystemFileWidgetComponent } from './components/common/Files/assign-system-file-widget/assign-system-file-widget.component';
import { MultiSelectDropdownComponent } from './components/general/multi-select-dropdown/multi-select-dropdown.component';
import { JobFileUploadWidgetComponent } from './components/jobs/job-file-upload-widget/job-file-upload-widget.component';
import { SubjectNotesListComponent } from './admin/jobs/subjects/subject-notes-list/subject-notes-list.component';
import { JobsSubjectsNotesGridComponent } from './components/grid/jobs-subjects-notes-grid/jobs-subjects-notes-grid.component';
import { SubjectCardComponent } from './admin/jobs/subjects/subject-card/subject-card.component';
import { SubjectNavBarComponent } from './admin/jobs/subjects/subject-nav-bar/subject-nav-bar.component';
import { SubjectDetailsEditWidgetComponent } from './components/jobs/subject-details-edit-widget/subject-details-edit-widget.component';
import { AutocompleteComponentComponent } from './services/autocomplete-component/autocomplete-component.component';
import { SubjectContactNumberAddWidgetComponent } from './components/jobs/subject-contact-number-add-widget/subject-contact-number-add-widget.component';
import { SubjectContactEmailEditWidgetComponent } from './components/jobs/subject-contact-email-edit-widget/subject-contact-email-edit-widget.component';
import { SubjectContactEmailAddWidgetComponent } from './components/jobs/subject-contact-email-add-widget/subject-contact-email-add-widget.component';
import { SubjectAgentBrandsComponent } from './admin/jobs/subjects/subject-agent-brands/subject-agent-brands.component';
import { SubjectJobTypeChangeComponent } from './admin/jobs/subjects/subject-job-type-change/subject-job-type-change.component';
import { SubjectStatusChangeComponent } from './admin/jobs/subjects/subject-status-change/subject-status-change.component';
import { SubjectCloseComponent } from './admin/jobs/subjects/subject-close/subject-close.component';
import { SendEmailWidgetComponent } from './components/communication/send-email-widget/send-email-widget.component';
import { AddCommunicationEmailRecipientWidgetComponent } from './components/communication/add-communication-email-recipient-widget/add-communication-email-recipient-widget.component';
import { SubjectDeleteWidgetComponent } from './components/jobs/subject-delete-widget/subject-delete-widget.component';
import { SubjectContactNumberEditWidgetComponent } from './components/jobs/subject-contact-number-edit-widget/subject-contact-number-edit-widget.component';
import { JobSubjectAttemptsGridComponent } from './components/grid/job-subject-attempts-grid/job-subject-attempts-grid.component';

import { SubjectAttemptDetailsWidgetComponent } from './components/jobs/subject-attempt-details-widget/subject-attempt-details-widget.component';
import { SubjectDetailsWidgetComponent } from './components/jobs/subject-details-widget/subject-details-widget.component';
import { JobsSubjectsGridComponent } from './components/grid/jobs-subjects-grid/jobs-subjects-grid.component';
import { SubjectDocumentsComponent } from './admin/jobs/subjects/subject-documents/subject-documents.component';
import { SubjectDocumentsCreateDocxMergeWidgetComponent } from './admin/jobs/subjects/subject-documents-create-docx-merge-widget/subject-documents-create-docx-merge-widget.component';
import { EditDocxSystemFileComponent } from './admin/system-file-manager/edit-docx-system-file/edit-docx-system-file.component';
import { CommunicationManagerComponent } from './admin/communication-manager/communication-manager.component';
import { SubjectComTypeViewComponent } from './admin/communication-manager/subject-com-type-view/subject-com-type-view.component';
import { UploadDocxThemeTemplateComponent } from './admin/communication-manager/upload-docx-theme-template/upload-docx-theme-template.component';
import { SubjectComTypeEditComponent } from './admin/communication-manager/subject-com-type-edit/subject-com-type-edit.component';
import { SubjectComTypeTemplateDocViewComponent } from './admin/communication-manager/subject-com-type-template-doc-view/subject-com-type-template-doc-view.component';
import { SubjectComTypeTemplateDocEditComponent } from './admin/communication-manager/subject-com-type-template-doc-edit/subject-com-type-template-doc-edit.component';
import { UploadDocxTemplateModalComponent } from './admin/communication-manager/upload-docx-template-modal/upload-docx-template-modal.component';
import { UploadEmailTemplateModalComponent } from './admin/communication-manager/upload-email-template-modal/upload-email-template-modal.component';
import { UploadDotTemplateModalComponent } from './admin/communication-manager/upload-dot-template-modal/upload-dot-template-modal.component';
import { SubjectComTypeTemplateDocCreateComponent } from './admin/communication-manager/subject-com-type-template-doc-create/subject-com-type-template-doc-create.component';
import { EditDocxTemplateFileComponent } from './admin/communication-manager/edit-docx-template-file/edit-docx-template-file.component';
import { TxcMailMergeComponent } from './txc-mail-merge/txc-mail-merge.component';
import { HotToastModule } from '@ngneat/hot-toast';
import { ReactiveFormsModule } from '@angular/forms';
import { UserDetailsWidgetComponent } from './components/users/user-details-widget/user-details-widget.component';
import { LostPasswordComponent } from './views/lost-password/lost-password.component';
import { PasswordStrengthWidgetComponent } from './components/users/password-strength-widget/password-strength-widget.component';
import { UserAvitarModalUploadComponent } from './admin/users/user-avitar-modal-upload/user-avitar-modal-upload.component';
import { UserPasswordExpiredModalComponent } from './components/users/user-password-expired-modal/user-password-expired-modal.component';
import { UserPasswordWidgetComponent } from './components/users/user-password-widget/user-password-widget.component';
import { JobsUrgentComponent } from './admin/jobs/jobs-urgent/jobs-urgent.component';
import { NotesGridComponent } from './components/grid/notes-grid/notes-grid.component';
import { JobsClosedComponent } from './admin/jobs/jobs-closed/jobs-closed.component';
import { CreateJobComponent } from './admin/jobs/create-job/create-job.component';
import { BrandCreateWidgetComponent } from './components/brands/brand-create-widget/brand-create-widget.component';
import { FileUploadsModalComponent } from './manager/file-uploads-modal/file-uploads-modal.component';
import { CreateJob2Component } from './admin/jobs/create-job-2/create-job-2.component';
import { JobPlaintiffAddWidgetComponent } from './components/jobs/job-plaintiff-add-widget/job-plaintiff-add-widget.component';
import { CreateJob3Component } from './admin/jobs/create-job-3/create-job-3.component';
import { JobDetailsEditWidgetComponent } from './components/jobs/job-details-edit-widget/job-details-edit-widget.component';
import { JobReportSubjectAddWidgetComponent } from './components/jobs/job-report-subject-add-widget/job-report-subject-add-widget.component';
import { EditJobComponent } from './admin/jobs/edit-job/edit-job.component';
import { SubjectCommunicationComponent } from './admin/jobs/subjects/subject-communication/subject-communication.component';
import { CompaniesHomeComponent } from './admin/companies-home/companies-home.component';
import { CompanyViewComponent } from './admin/companies-home/company-view/company-view.component';
import { CompanyEditComponent } from './admin/companies-home/company-edit/company-edit.component';
import { MyobApiCustomerClientSyncToolsWidgetComponent } from './components/myob/myob-api-customer-client-sync-tools-widget/myob-api-customer-client-sync-tools-widget.component';
import { MyobApiCustomerSupplierSyncToolsWidgetComponent } from './components/myob/myob-api-customer-supplier-sync-tools-widget/myob-api-customer-supplier-sync-tools-widget.component';
import { CompanyDeleteWidgetComponent } from './admin/companies-home/company-delete-widget/company-delete-widget.component';
import { UsersListComponent } from './admin/users/users-list/users-list.component';
import { UserViewComponent } from './admin/users/user-view/user-view.component';
import { DeleteUserWidgetComponent } from './components/users/delete-user-widget/delete-user-widget.component';
import { UserEditComponent } from './admin/users/user-edit/user-edit.component';
import { UserCreateComponent } from './admin/users/user-create/user-create.component';
import { CompanyCreateComponent } from './admin/companies-home/company-create/company-create.component';
import { SystemFileManagerComponent } from './admin/system-file-manager/system-file-manager.component';
import { SystemFileViewComponent } from './admin/system-file-manager/system-file-view/system-file-view.component';
import { FileDetailsWidgetComponent } from './components/common/Files/file-details-widget/file-details-widget.component';
import { SystemFileEditComponent } from './admin/system-file-manager/system-file-edit/system-file-edit.component';
import { SystemDocEditComponent } from './admin/system-file-manager/system-doc-edit/system-doc-edit.component';
import { ViewDocxSystemFileComponent } from './admin/system-file-manager/view-docx-system-file/view-docx-system-file.component';
import { SystemCommunicationHistoryComponent } from './admin/system-communication-history/system-communication-history.component';
import { SystemNoteManagerComponent } from './admin/system-note-manager/system-note-manager.component';
import { DocxThemeTemplateGridComponent } from './admin/communication-manager/docx-theme-template-grid/docx-theme-template-grid.component';
import { JobsSubjectsCreatedReportComponent } from './admin/system-reports/jobs-subjects-created-report/jobs-subjects-created-report.component';
import { AgentPerformanceMetricsComponent } from './admin/system-reports/agent-performance-metrics/agent-performance-metrics.component';
import { StaffPerformanceMetricsComponent } from './admin/system-reports/staff-performance-metrics/staff-performance-metrics.component';
import { NewSystemContactsReportComponent } from './admin/system-reports/new-system-contacts-report/new-system-contacts-report.component';
import { SystemLogManagerComponent } from './admin/system-log-manager/system-log-manager.component';
import { SystemSettingsComponent } from './admin/system-settings/system-settings.component';
import { SystemJobTypesComponent } from './admin/system-settings/system-job-types/system-job-types.component';
import { UpdateTypesComponent } from './admin/jobs/create-job-type/update-types/update-types.component';
import { CreateTypesComponent } from './admin/jobs/create-job-type/create-types/create-types.component';

// Bootstrap Modal Alternative

import { PaginationService, PaginationControlsComponent, NgxPaginationModule } from 'ngx-pagination';
import { CreateJobTypeComponent } from './admin/jobs/create-job-type/create-job-type.component';
import { SystemJobTypeLocationsComponent } from './admin/system-settings/system-job-types/system-job-type-locations/system-job-type-locations.component';
import { UpdateLocationComponent } from './admin/jobs/create-job-type/update-location/update-location.component';
import { CreateLocationComponent } from './admin/jobs/create-job-type/create-location/create-location.component';
import { SystemLocationCourtsComponent } from './admin/system-settings/system-job-types/system-location-courts/system-location-courts.component';
import { UpdateCourtComponent } from './admin/jobs/create-job-type/update-court/update-court.component';
import { CreateCourtComponent } from './admin/jobs/create-job-type/create-court/create-court.component';
import { SystemCourtDocumentTypesComponent } from './admin/system-settings/system-job-types/system-court-document-types/system-court-document-types.component';
import { UpdateDocumentComponent } from './admin/jobs/create-job-type/update-document/update-document.component';
import { CreateDocumentComponent } from './admin/jobs/create-job-type/create-document/create-document.component';
import { SystemDocumentTypeAffidavitsComponent } from './admin/system-settings/system-job-types/system-document-type-affidavits/system-document-type-affidavits.component';
import { SystemJobTypesBreadcrumbsComponent } from './admin/system-settings/system-job-types/system-job-types-breadcrumbs/system-job-types-breadcrumbs.component';
import { UpdateAffidavitComponent } from './admin/jobs/create-job-type/update-affidavit/update-affidavit.component';
import { CreateAffidavitComponent } from './admin/jobs/create-job-type/create-affidavit/create-affidavit.component';
import { CreateSubjectComTypeTemplateFromAffidavitModalComponent } from './admin/communication-manager/create-subject-com-type-template-from-affidavit-modal/create-subject-com-type-template-from-affidavit-modal.component';
import { SystemJobServiceRulesComponent } from './admin/system-settings/system-job-types/system-job-service-rules/system-job-service-rules.component';
import { UpdateServiceRuleComponent } from './admin/jobs/create-job-type/update-service-rule/update-service-rule.component';
import { CreateServiceRuleComponent } from './admin/jobs/create-job-type/create-service-rule/create-service-rule.component';
import { SystemJobServiceTimeframesComponent } from './admin/system-settings/system-job-types/system-job-service-timeframes/system-job-service-timeframes.component';
import { UpdateServiceTimeframeComponent } from './admin/jobs/create-job-type/update-service-timeframe/update-service-timeframe.component';
import { CreateServiceTimeframeComponent } from './admin/jobs/create-job-type/create-service-timeframe/create-service-timeframe.component';
import { SystemSubjectServiceTypesComponent } from './admin/system-settings/system-job-types/system-subject-service-types/system-subject-service-types.component';
import { UpdateSubjectServiceTypeComponent } from './admin/jobs/create-job-type/update-subject-service-type/update-subject-service-type.component';
import { CreateSubjectServiceTypeComponent } from './admin/jobs/create-job-type/create-subject-service-type/create-subject-service-type.component';
import { AccountingBillingTasksComponent } from './admin/system-settings/accounting-billing-tasks/accounting-billing-tasks.component';
import { EditBillingTaskWidgetComponent } from './admin/system-settings/accounting-billing-tasks/edit-billing-task-widget/edit-billing-task-widget.component';
import { CreateBillingTaskWidgetComponent } from './admin/system-settings/accounting-billing-tasks/create-billing-task-widget/create-billing-task-widget.component';
import { AccountingCostTasksComponent } from './admin/system-settings/accounting-cost-tasks/accounting-cost-tasks.component';
import { EditCostTaskWidgetComponent } from './admin/system-settings/accounting-cost-tasks/edit-cost-task-widget/edit-cost-task-widget.component';
import { CreateCostTaskWidgetComponent } from './admin/system-settings/accounting-cost-tasks/create-cost-task-widget/create-cost-task-widget.component';
import { AccountingMyobAccountCodesComponent } from './admin/system-settings/accounting-myob-account-codes/accounting-myob-account-codes.component';
import { MyobAccountCodesLiveGridComponent } from './components/grid/myob-account-codes-live-grid/myob-account-codes-live-grid.component';
import { MyobAccountCodesGridComponent } from './components/grid/myob-account-codes-grid/myob-account-codes-grid.component';
import { AccountingMyobTaxCodesComponent } from './admin/system-settings/accounting-myob-tax-codes/accounting-myob-tax-codes.component';
import { MyobTaxCodesLiveGridComponent } from './components/grid/myob-tax-codes-live-grid/myob-tax-codes-live-grid.component';
import { MyobTaxCodesGridComponent } from './components/grid/myob-tax-codes-grid/myob-tax-codes-grid.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

import { SubjectBillingTabComponent } from './admin/jobs/subjects/subject-billing-tab/subject-billing-tab.component';
import { SubjectBillingComponent } from './admin/jobs/subjects/subject-billing/subject-billing.component';
import { ClientInvoiceBulkPaymentWidgetComponent } from './components/invoices/client-invoice-bulk-payment-widget/client-invoice-bulk-payment-widget.component';
import { MyobApiInvoicePaymentSyncToolsWidgetComponent } from './components/myob/myob-api-invoice-payment-sync-tools-widget/myob-api-invoice-payment-sync-tools-widget.component';
import { MyobApiInvoiceSyncToolsWidgetComponent } from './components/myob/myob-api-invoice-sync-tools-widget/myob-api-invoice-sync-tools-widget.component';
import { BrandInvoicesGridComponent } from './components/grid/brand-invoices-grid/brand-invoices-grid.component';
import { UpdateInvoiceWidgetComponent } from './components/invoices/update-invoice-widget/update-invoice-widget.component';
import { InvoicePdfFileListWidgetComponent } from './components/invoices/invoice-pdf-file-list-widget/invoice-pdf-file-list-widget.component';
import { CreateInvoicePaymentWidgetComponent } from './components/invoices/create-invoice-payment-widget/create-invoice-payment-widget.component';
import { InvoicePaymentWidgetComponent } from './components/invoices/invoice-payment-widget/invoice-payment-widget.component';
import { UpdateInvoicePaymentWidgetComponent } from './components/invoices/update-invoice-payment-widget/update-invoice-payment-widget.component';
import { SubjectBillingItemsGridComponent } from './components/grid/subject-billing-items-grid/subject-billing-items-grid.component';
import { CreateInvoiceWidgetComponent } from './components/invoices/create-invoice-widget/create-invoice-widget.component';
import { InvoiceItemRowFormWidgetComponent } from './components/invoices/invoice-item-row-form-widget/invoice-item-row-form-widget.component';
import { AddSubjectBillingItemWidgetComponent } from './admin/jobs/subjects/subject-billing/add-subject-billing-item-widget/add-subject-billing-item-widget.component';
import { InvoiceStatusChangeWidgetComponent } from './components/invoices/invoice-status-change-widget/invoice-status-change-widget.component';
import { InvoicePaymentStatusChangeWidgetComponent } from './components/invoices/invoice-payment-status-change-widget/invoice-payment-status-change-widget.component';
import { InvoiceCommunicationStatusChangeWidgetComponent } from './components/invoices/invoice-communication-status-change-widget/invoice-communication-status-change-widget.component';
import { InvoiceLogWidgetComponent } from './components/invoices/invoice-log-widget/invoice-log-widget.component';
import { AddSubjectCostItemWidgetComponent } from './admin/jobs/subjects/subject-billing/add-subject-cost-item-widget/add-subject-cost-item-widget.component';
import { CreateWorkOrderWidgetComponent } from './components/work-orders/create-work-order-widget/create-work-order-widget.component';
import { SubjectCostTabComponent } from './admin/jobs/subjects/subject-cost-tab/subject-cost-tab.component';
import { SubjectCostComponent } from './admin/jobs/subjects/subject-billing/subject-cost/subject-cost.component';
import { SubjectAgentCostWidgetComponent } from './admin/jobs/subjects/subject-billing/subject-agent-cost-widget/subject-agent-cost-widget.component';
import { MyobApiPurchaseSyncToolsWidgetComponent } from './components/myob/myob-api-purchase-sync-tools-widget/myob-api-purchase-sync-tools-widget.component';
import { WorkOrdersGridComponent } from './components/grid/work-orders-grid/work-orders-grid.component';
import { UpdateWorkOrderWidgetComponent } from './components/work-orders/update-work-order-widget/update-work-order-widget.component';
import { WorkOrderStatusChangeWidgetComponent } from './components/work-orders/work-order-status-change-widget/work-order-status-change-widget.component';
import { WorkOrderPaymentStatusChangeWidgetComponent } from './components/work-orders/work-order-payment-status-change-widget/work-order-payment-status-change-widget.component';
import { WorkOrderCommunicationStatusChangeWidgetComponent } from './components/work-orders/work-order-communication-status-change-widget/work-order-communication-status-change-widget.component';
import { WorkOrderItemRowFormWidgetComponent } from './components/work-orders/work-order-item-row-form-widget/work-order-item-row-form-widget.component';
import { CreateWorkOrderPaymentWidgetComponent } from './components/work-orders/create-work-order-payment-widget/create-work-order-payment-widget.component';
import { WorkOrderPaymentWidgetComponent } from './components/work-orders/work-order-payment-widget/work-order-payment-widget.component';
import { MyobApiPurchasePaymentSyncToolsWidgetComponent } from './components/myob/myob-api-purchase-payment-sync-tools-widget/myob-api-purchase-payment-sync-tools-widget.component';
import { WorkOrderBulkPaymentWidgetComponent } from './components/work-orders/work-order-bulk-payment-widget/work-order-bulk-payment-widget.component';
import { BrandWorkOrdersGridComponent } from './components/grid/brand-work-orders-grid/brand-work-orders-grid.component';
import { SubjectCostItemsGridComponent } from './components/grid/subject-cost-items-grid/subject-cost-items-grid.component';
import { InvoicesComponent } from './admin/accounting/invoices/invoices.component';
import { InvoicesGridComponent } from './components/grid/invoices-grid/invoices-grid.component';
import { MyobServiceInvoicesGridComponent } from './components/grid/myob-service-invoices-grid/myob-service-invoices-grid.component';
import { ClientOutstandingsComponent } from './admin/accounting/client-outstandings/client-outstandings.component';
import { PaymentsBulkComponent } from './admin/accounting/payments-bulk/payments-bulk.component';
import { MyobCustomersComponent } from './admin/accounting/myob-customers/myob-customers.component';
import { UserService2 } from './services/user2.service';
import { MyobContactService } from './services/myob-contact.service';
import { MyobCustomersGridComponent } from './components/grid/myob-customers-grid/myob-customers-grid.component';
import { PaymentsComponent } from './admin/accounting/payments/payments.component';
import { PaymentsGridComponent } from './components/grid/payments-grid/payments-grid.component';
import { MyobPaymentsGridComponent } from './components/grid/myob-payments-grid/myob-payments-grid.component';
import { InvoicesSuppliersComponent } from './admin/accounting/invoices-suppliers/invoices-suppliers.component';
import { MyobServiceWorkOrdersGridComponent } from './components/grid/myob-service-work-orders-grid/myob-service-work-orders-grid.component';
import { AgentOutstandingsComponent } from './admin/accounting/agent-outstandings/agent-outstandings.component';
import { PaymentsBulkSupplierComponent } from './admin/accounting/payments-bulk-supplier/payments-bulk-supplier.component';
import { MyobSuppliersComponent } from './admin/accounting/myob-suppliers/myob-suppliers.component';
import { MyobSuppliersGridComponent } from './components/grid/myob-suppliers-grid/myob-suppliers-grid.component';
import { MyobPaymentsSuppliersComponent } from './admin/accounting/myob-payments-suppliers/myob-payments-suppliers.component';
import { WorkOrderPaymentsGridComponent } from './components/grid/work-order-payments-grid/work-order-payments-grid.component';
import { MyobPurchasePaymentsGridComponent } from './components/grid/myob-purchase-payments-grid/myob-purchase-payments-grid.component';
import { MyobLoginComponent } from './admin/myob-login/myob-login.component';
import { UploadProgressComponent } from './components/jobs/job-file-upload-widget/upload-progress/upload-progress.component';
import { DndDirective } from './components/jobs/job-file-upload-widget/dnd.directives';
import { MaterialModule } from './modules/material.module';
import { JobFileUploadWidget2Component } from './components/jobs/job-file-upload-widget2/job-file-upload-widget2.component';
import { DropzoneDirective } from './directives/dropzone.directives';
import { JobFileUploadWidget3Component } from './components/jobs/job-file-upload-widget3/job-file-upload-widget3.component';

// NGX Bootstrap Modals and tools
// import { ngfModule, ngf } from 'angular-file'; /// Rebuild the Uploader.
import { NgxFileDropModule } from 'ngx-file-drop';
import { StaffDashboardComponent } from './staff/staff-dashboard/staff-dashboard.component';
import { CreateJobStatusComponent } from './admin/jobs/create-job-status/create-job-status.component';
import { SubjectNotesTabComponent } from './admin/jobs/subjects/subject-notes-tab/subject-notes-tab.component';
import { ClientDashboardComponent } from './client/client-dashboard/client-dashboard.component';
import { ClientJobsComponent } from './client/client-jobs/client-jobs.component';
import { ClientJobCreateComponent } from './client/client-jobs/client-job-create/client-job-create.component';
import { ClientJobCreate2Component } from './client/client-jobs/client-job-create2/client-job-create2.component';
import { ClientJobCreate3Component } from './client/client-jobs/client-job-create3/client-job-create3.component';
import { ClientJobViewComponent } from './client/client-jobs/client-job-view/client-job-view.component';
import { ClientJobSubjectComponent } from './client/client-jobs/client-job-subject/client-job-subject.component';
import { ClientProfileComponent } from './client/client-profile/client-profile.component';
import { BrandDetailsWidgetComponent } from './components/brands/brand-details-widget/brand-details-widget.component';
import { ClientApiAccessWidgetComponent } from './components/client-api/client-api-access-widget/client-api-access-widget.component';
import { ClientProfileEditComponent } from './client/client-profile-edit/client-profile-edit.component';
import { BrandDetailsEditWidgetComponent } from './components/brands/brand-details-edit-widget/brand-details-edit-widget.component';
import { ClientUserProfileComponent } from './client/client-user-profile/client-user-profile.component';
import { UserDetailsEditWidgetComponent } from './components/users/user-details-edit-widget/user-details-edit-widget.component';
import { ClientUserProfileEditComponent } from './client/client-user-profile-edit/client-user-profile-edit.component';
import { ClientUsersComponent } from './client/client-users/client-users.component';
import { UsersGridComponent } from './components/grid/users-grid/users-grid.component';
import { AgentComponent } from './agent/agent/agent.component';
import { AgentJobsComponent } from './agent/agent-jobs/agent-jobs.component';
import { AgentViewSubjectComponent } from './agent/agent-view-subject/agent-view-subject.component';
import { SubjectAttendenceComponent } from './admin/jobs/subjects/subject-attendence/subject-attendence.component';
import { UserProfileDisplayComponent } from './admin/jobs/subjects/user-profile-display/user-profile-display.component';
import { AgentJobViewComponent } from './agent/agent-job-view/agent-job-view.component';
import { AgentJobSubjectComponent } from './agent/agent-job-subject/agent-job-subject.component';
import { AgentProfileComponent } from './agent/agent-profile/agent-profile.component';
import { AgentProfileEditComponent } from './agent/agent-profile-edit/agent-profile-edit.component';
import { AgentUserProfileComponent } from './agent/agent-user-profile/agent-user-profile.component';
import { AgentUserProfileEditComponent } from './agent/agent-user-profile-edit/agent-user-profile-edit.component';
import { AgentUsersComponent } from './agent/agent-users/agent-users.component';
import { EditDocxThemeFileComponent } from './admin/system-file-manager/edit-docx-theme-file/edit-docx-theme-file.component';

import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { SubjectComTypeCreateComponent } from './admin/communication-manager/subject-com-type-create/subject-com-type-create.component';
import { JobDeleteWidgetComponent } from './components/jobs/job-delete-widget/job-delete-widget.component';
import { SubjectServiceComponent } from './admin/jobs/subjects/subject-service/subject-service.component';
import { SubjectServiceListComponent } from './admin/jobs/subjects/subject-service/subject-service-list/subject-service-list.component';
import { ReportNewAgentContactsComponent } from './admin/system-reports/new-system-contacts-report/report-new-agent-contacts/report-new-agent-contacts.component';
import { DocxInUseCheckWidgetComponent } from './components/common/Files/docx-in-use-check-widget/docx-in-use-check-widget.component';
import { AssignSystemNoteWidgetComponent } from './components/common/notes/assign-system-note-widget/assign-system-note-widget.component';
import { NoteDetailsWidgetComponent } from './components/common/notes/note-details-widget/note-details-widget.component';
import { CreateAffidavitWidgetComponent } from './admin/jobs/create-job-type/create-affidavit-widget/create-affidavit-widget.component';

// import { FileDropModule } from 'ngx-file-drop';

// import { FileUploadModule } from "ng2-file-upload";

import { ngfModule, ngf } from 'angular-file';
import { JobFileUploadWidget3AttemptsComponent } from './components/jobs/job-file-upload-widget3-attempts/job-file-upload-widget3-attempts.component';
import { JobsFileAttachedWidgetComponent } from './components/jobs/jobs-file-attached-widget/jobs-file-attached-widget.component';
import { SubjectAttemptEditWidgetComponent } from './components/jobs/subject-attempt-edit-widget/subject-attempt-edit-widget.component';
import { MyobServiceInvoiceComparitorComponent } from './components/grid/myob-service-invoice-comparitor/myob-service-invoice-comparitor.component';
import { MyobDailyTasksComponent } from './admin/accounting/myob-daily-tasks/myob-daily-tasks.component';
import { UpdateWorkOrderPaymentWidgetComponent } from './components/work-orders/update-work-order-payment-widget/update-work-order-payment-widget.component';
import { ClientInvoicesComponent } from './client/client-invoices/client-invoices.component';
import { AgentInvoicesComponent } from './agent/agent-invoices/agent-invoices.component';
import { ClientJobCreateWizardStep1Component } from './client/client-jobs/client-job-create-wizard-step1/client-job-create-wizard-step1.component';
import { ClientJobCreateWizardStep2Component } from './client/client-jobs/client-job-create-wizard-step2/client-job-create-wizard-step2.component';
import { JobDetailsEditWidgetClientComponent } from './components/jobs/job-details-edit-widget-client/job-details-edit-widget-client.component';
import { ClientJobCreateWizardStep3Component } from './client/client-jobs/client-job-create-wizard-step3/client-job-create-wizard-step3.component';
import { ClientJobsUrgentComponent } from './client/client-jobs-urgent/client-jobs-urgent.component';
import { ClientJobStatusKeyWidgetComponent } from './client/client-job-status-key-widget/client-job-status-key-widget.component';
import { UpdateJobStatusWidgetComponent } from './components/jobs/update-job-status-widget/update-job-status-widget.component';
import { BrandGlobalCompanyKeyWidgetComponent } from './components/brands/brand-global-company-key-widget/brand-global-company-key-widget.component';
import { SystemForceLogoutWidgetComponent } from './admin/system-force-logout-widget/system-force-logout-widget.component';
import { SystemInvestigationComponent } from './admin/system-investigation/system-investigation.component';
import { SystemActionListsComponent } from './admin/system-action-lists/system-action-lists.component';
import { SystemActionListComponent } from './admin/system-action-list/system-action-list.component';
import { ActionListWidgetComponent } from './components/actions/action-list-widget/action-list-widget.component';
import { SystemLogCountWidgetComponent } from './components/actions/system-log-count-widget/system-log-count-widget.component';
import { AccumulationChartAllModule, BulletChartModule, ChartModule, DateTime, DateTimeCategory } from '@syncfusion/ej2-angular-charts';
import { SystemLogViewComponent } from './admin/system-log-manager/system-log-view/system-log-view.component';
import { SystemLogViewWidgetComponent } from './components/actions/system-log-view-widget/system-log-view-widget.component';
import { SystemLogTypesComponent } from './admin/system-settings/system-log-types/system-log-types.component';
import { UpdateSystemLogTypeComponent } from './admin/system-settings/update-system-log-type/update-system-log-type.component';

// Imported syncfusion Slider module from inputs package
import { SliderModule } from '@syncfusion/ej2-angular-inputs';
import { SystemAutomationsComponent } from './admin/system-automations/system-automations/system-automations.component';
import { SystemAutomationCreateComponent } from './admin/system-automations/system-automation-create/system-automation-create.component';
import { CreateSystemLogTypeComponent } from './admin/system-settings/create-system-log-type/create-system-log-type.component';
import { SystemAutomationUpdateComponent } from './admin/system-automations/system-automation-update/system-automation-update.component';
import { SystemAutomationComponent } from './admin/system-automations/system-automation/system-automation.component';
import { VariableCodeBlocksComponent } from './admin/system-variables/variable-code-blocks/variable-code-blocks.component';
import { VariableCodeBlocksGridComponent } from './admin/system-variables/variable-code-blocks-grid/variable-code-blocks-grid.component';
import { VariableCodeBlockCreateWidgetComponent } from './admin/system-variables/variable-code-block-create-widget/variable-code-block-create-widget.component';
import { VariableCodeBlockCreateComponent } from './admin/system-variables/variable-code-block-create/variable-code-block-create.component';
import { VariableCodeBlockUpdateWidgetComponent } from './admin/system-variables/variable-code-block-update-widget/variable-code-block-update-widget.component';
import { VariableCodeBlockUpdateComponent } from './admin/system-variables/variable-code-block-update/variable-code-block-update.component';
import { CodemirrorModule } from '@ctrl/ngx-codemirror';
import { QRCodeModule } from 'angularx-qrcode';
import { WooPromotionVariableModalComponent } from './admin/system-variables/woo-promotion-variable-modal/woo-promotion-variable-modal.component';
import { HtmlEditorModalWidgetComponent } from './admin/system-automations/html-editor-modal-widget/html-editor-modal-widget.component';
import { SystemLogTypeDataSectorConditionsComponent } from './admin/system-settings/system-log-type-data-sector-conditions/system-log-type-data-sector-conditions.component';
import { SystemLogTypeDataSectorConditionUpdateComponent } from './admin/system-settings/system-log-type-data-sector-condition-update/system-log-type-data-sector-condition-update.component';
import { SystemLogTypeDataSectorConditionCreateComponent } from './admin/system-settings/system-log-type-data-sector-condition-create/system-log-type-data-sector-condition-create.component';
import { SystemLogTypeDataSectorConditionComponent } from './admin/system-settings/system-log-type-data-sector-condition/system-log-type-data-sector-condition.component';
import { SystemLogTypeDataSectorsComponent } from './admin/system-settings/system-log-type-data-sectors/system-log-type-data-sectors.component';
import { SystemLogTypeDataSectorComponent } from './admin/system-settings/system-log-type-data-sector/system-log-type-data-sector.component';
import { SystemLogTypeDataSectorCreateComponent } from './admin/system-settings/system-log-type-data-sector-create/system-log-type-data-sector-create.component';
import { SystemLogTypeDataSectorUpdateComponent } from './admin/system-settings/system-log-type-data-sector-update/system-log-type-data-sector-update.component';
import { SystemLogTypeComponent } from './admin/system-settings/system-log-type/system-log-type.component';
import { SystemLogTypeDataSectorTypesComponent } from './admin/system-settings/system-log-type-data-sector-types/system-log-type-data-sector-types.component';
import { SystemLogTypeDataSectorTypeComponent } from './admin/system-settings/system-log-type-data-sector-type/system-log-type-data-sector-type.component';
import { SystemLogTypeDataSectorTypeCreateComponent } from './admin/system-settings/system-log-type-data-sector-type-create/system-log-type-data-sector-type-create.component';
import { SystemLogTypeDataSectorTypeUpdateComponent } from './admin/system-settings/system-log-type-data-sector-type-update/system-log-type-data-sector-type-update.component';
import { SystemLogTypeDataSSystemLogTypeDataSectorConditionComponent } from './admin/system-settings/system-log-type-data-ssystem-log-type-data-sector-condition/system-log-type-data-ssystem-log-type-data-sector-condition.component';
import { AttemptGridDateLocalWidgetComponent } from './components/grid/job-subject-attempts-grid/attempt-grid-date-local-widget/attempt-grid-date-local-widget.component';
import { SubjectServiceOutcomeTemplatesComponent } from './admin/system-settings/subject-service-outcome-templates/subject-service-outcome-templates.component';
import { SubjectServiceOutcomeTemplateCreateComponent } from './admin/system-settings/subject-service-outcome-template-create/subject-service-outcome-template-create.component';
import { SubjectServiceOutcomeTemplateComponent } from './admin/system-settings/subject-service-outcome-template/subject-service-outcome-template.component';
import { SubjectServiceOutcomeTemplateUpdateComponent } from './admin/system-settings/subject-service-outcome-template-update/subject-service-outcome-template-update.component';
import { AppRoutesComponent } from './admin/system-routes/app-routes/app-routes.component';
import { AppRoutesGridComponent } from './admin/system-routes/app-routes-grid/app-routes-grid.component';
import { AppRouteCreateComponent } from './admin/system-routes/app-route-create/app-route-create.component';
import { AppRouteUpdateComponent } from './admin/system-routes/app-route-update/app-route-update.component';
import { AppRouteComponent } from './admin/system-routes/app-route/app-route.component';
import { AppRouteCreateWidgetComponent } from './admin/system-routes/app-route-create-widget/app-route-create-widget.component';
import { AppRouteUpdateWidgetComponent } from './admin/system-routes/app-route-update-widget/app-route-update-widget.component';
import { AppRouteWidgetComponent } from './admin/system-routes/app-route-widget/app-route-widget.component';
import { AppRoutesDiagramHierarchialComponent } from './admin/system-routes/app-routes-diagram-hierarchial/app-routes-diagram-hierarchial.component';
import { BpmnDiagramsService, ComplexHierarchicalTreeService, ConnectorBridgingService, ConnectorEditingService, DataBindingService, DiagramContextMenuService, DiagramModule, HierarchicalTreeService, LayoutAnimationService, MindMapService, PrintAndExportService, RadialTreeService, SnappingService, SymmetricLayoutService, UndoRedoService } from '@syncfusion/ej2-angular-diagrams';
import { ProjectsHomeComponent } from './admin/jobs/projects-home/projects-home.component';
import { ProjectsGridComponent } from './components/grid/projects-grid/projects-grid.component';
import { EditJobProjectWizardComponent } from './components/projects/edit-job-project-wizard/edit-job-project-wizard.component';
import { CreateJobProjectWidgetComponent } from './components/projects/create-job-project-widget/create-job-project-widget.component';
import { ProjectsEditComponent } from './admin/jobs/projects-home/projects-edit/projects-edit.component';
import { ProjectAdminViewComponent } from './admin/jobs/projects-home/project-admin-view/project-admin-view.component';
import { AppRouteBillingItemsGridComponent } from './components/grid/app-route-billing-items-grid/app-route-billing-items-grid.component';
import { AppRouteBillingItemUpdateComponent } from './admin/system-routes/app-route-billing-item-update/app-route-billing-item-update.component';
import { AppRoutesDiagramKanPanDataComponentComponent } from './admin/system-routes/app-routes-diagram-kan-pan-data-component/app-routes-diagram-kan-pan-data-component.component';
import { KanbanModule } from '@syncfusion/ej2-angular-kanban';
import { SubjectCommunicationWithVarsComponent } from './admin/jobs/subjects/subject-communication-with-vars/subject-communication-with-vars.component';
import { ViewCommunicationHistoryWidgetComponent } from './components/communication/view-communication-history-widget/view-communication-history-widget.component';
import { SubjectUrgentOutcomeTemplatesComponent } from './admin/system-settings/subject-urgent-outcome-templates/subject-urgent-outcome-templates.component';
import { SubjectUrgentOutcomeTemplateUpdateComponent } from './admin/system-settings/subject-urgent-outcome-template-update/subject-urgent-outcome-template-update.component';
import { SubjectUrgentOutcomeTemplateCreateComponent } from './admin/system-settings/subject-urgent-outcome-template-create/subject-urgent-outcome-template-create.component';
import { SubjectUrgentOutcomeTemplateComponent } from './admin/system-settings/subject-urgent-outcome-template/subject-urgent-outcome-template.component';
import { SystemLogWidgetComponent } from './admin/system-log-manager/system-log-widget/system-log-widget.component';
import { JobsSubjectsTimelineGridComponent } from './components/grid/jobs-subjects-timeline-grid/jobs-subjects-timeline-grid.component';
import { HighlighterPipe } from './pipes/highligter.pipe';
import { NoteEditWidgetComponent } from './components/common/notes/note-edit-widget/note-edit-widget.component';
import { DashboardLayoutModule, SplitterModule } from '@syncfusion/ej2-angular-layouts';

import { SystemHelpVarsComponent } from './admin/system-help-vars/system-help-vars.component';
import { AppRouteHelperPlayerWidgetComponent } from './admin/system-routes/app-route-helper-player-widget/app-route-helper-player-widget.component';
import { AppRoutesDiagramKanBanComponent } from './admin/system-routes/app-routes-diagram-kan-ban/app-routes-diagram-kan-ban.component';
import { AppRoutesDiagramKanBanSearchComponent } from './admin/system-routes/app-routes-diagram-kan-ban-search/app-routes-diagram-kan-ban-search.component';
import { UnderTheHoodWidgetComponent } from './admin/system-routes/under-the-hood-widget/under-the-hood-widget.component';
import { MyobPaymentsGridInvoiceComponent } from './components/grid/myob-payments-grid-invoice/myob-payments-grid-invoice.component';
import { PaymentsGridInvoiceComponent } from './components/grid/payments-grid-invoice/payments-grid-invoice.component';
import { MyobServiceInvoicesGridInvoiceComponent } from './components/grid/myob-service-invoices-grid-invoice/myob-service-invoices-grid-invoice.component';
import { MyobCustomersGridBrandComponent } from './components/grid/myob-customers-grid-brand/myob-customers-grid-brand.component';
import { MyobServiceWorkOrdersGridWorkOrderComponent } from './components/grid/myob-service-work-orders-grid-work-order/myob-service-work-orders-grid-work-order.component';
import { WorkOrderPaymentsGridWorkOrderComponent } from './components/grid/work-order-payments-grid-work-order/work-order-payments-grid-work-order.component';
import { WorkOrderLogWidgetComponent } from './components/work-orders/work-order-log-widget/work-order-log-widget.component';
import { SubjectServiceMultipleWidgetComponent } from './admin/jobs/subjects/subject-service-multiple-widget/subject-service-multiple-widget.component';
import { SubjectCardLayoutsDashboardComponent } from './admin/jobs/subjects/subject-card-layouts-dashboard/subject-card-layouts-dashboard.component';
import { QuicklinksMenusWidgetComponent } from './components/general/quicklinks-menus-widget/quicklinks-menus-widget.component';
import { ScrollTopComponent } from './components/common/scroll-top/scroll-top.component';
import { SubjectActivityLogWidgetComponent } from './components/logs/subject-activity-log-widget/subject-activity-log-widget.component';
import { SubjectActivityLogGraphWidgetComponent } from './components/logs/subject-activity-log-graph-widget/subject-activity-log-graph-widget.component';
import { Login2FAComponent } from './login2-fa/login2-fa.component';
import { LoginEnterCodeTFAComponent } from './login-enter-code-tfa/login-enter-code-tfa.component';
import { LoginUserSetupTFAComponent } from './login-user-setup-tfa/login-user-setup-tfa.component';
import { FormatFileSizePipe } from './pipes/format-file-size.pipe';

    // import { AppRouteCreateComponent } from './admin/system-routes/app-route-create/app-route-create.component';
    // import { AppRouteUpdateComponent } from './admin/system-routes/app-route-update/app-route-update.component';
    // import { AppRouteComponent } from './admin/system-routes/app-route/app-route.component';
    // import { AppRoutesDiagramAppNetworkComponent } from './admin/system-routes/app-routes-diagram-app-network/app-routes-diagram-app-network.component';
    // import { AppRoutesDiagramHierarchialComplexComponent } from './admin/system-routes/app-routes-diagram-hierarchial-complex/app-routes-diagram-hierarchial-complex.component';
    // import { AppRoutesDiagramHierarchialComponent } from './admin/system-routes/app-routes-diagram-hierarchial/app-routes-diagram-hierarchial.component';
    // import { AppRoutesDiagramKanBanComponent } from './admin/system-routes/app-routes-diagram-kan-ban/app-routes-diagram-kan-ban.component';
    // import { AppRoutesDiagramKanPanDataComponent } from './admin/system-routes/app-routes-diagram-kan-pan-data/app-routes-diagram-kan-pan-data.component';
    // import { AppRoutesDiagramLocalDataComponent } from './admin/system-routes/app-routes-diagram-local-data/app-routes-diagram-local-data.component';
    // import { AppRoutesDiagramOnInitComponent } from './admin/system-routes/app-routes-diagram-on-init/app-routes-diagram-on-init.component';
    // import { AppRoutesDiagramOverViewComponent } from './admin/system-routes/app-routes-diagram-over-view/app-routes-diagram-over-view.component';
    // // import { AppRoutesDiagramProposalComponent } from './admin/system-routes/app-routes-diagram-proposal/app-routes-diagram-proposal.component';
    // import { AppRoutesDiagramRadialTreeComponent } from './admin/system-routes/app-routes-diagram-radial-tree/app-routes-diagram-radial-tree.component';
    // import { AppRoutesDiagramUsersComponent } from './admin/system-routes/app-routes-diagram-users/app-routes-diagram-users.component';
    // import { AppRoutesDiagramComponent } from './admin/system-routes/app-routes-diagram/app-routes-diagram.component';
    // import { AppRoutesGridTreeComponent } from './admin/system-routes/app-routes-grid-tree/app-routes-grid-tree.component';
    // import { AppRoutesGridComponent } from './admin/system-routes/app-routes-grid/app-routes-grid.component';
    // import { AppRoutesTreeListComponent } from './admin/system-routes/app-routes-tree-list/app-routes-tree-list.component';
    // import { AppRoutesTreeMapComponent } from './admin/system-routes/app-routes-tree-map/app-routes-tree-map.component';
    // import { AppRoutesComponent } from './admin/system-routes/app-routes/app-routes.component';
// import { CodemirrorModule } from '@ctrl/ngx-codemirror';

import { TreeGridModule } from '@syncfusion/ej2-angular-treegrid';
import { JobsGridTreeComponent } from './components/grid/jobs-grid-tree/jobs-grid-tree.component';
import { JobsSortingComponent } from './admin/jobs/jobs-sorting/jobs-sorting.component';
import { JobsGridSortingComponent } from './components/grid/jobs-grid-sorting/jobs-grid-sorting.component';
import { SystemActivityDashbardComponent } from './admin/system-reports/activity/system-activity-dashbard/system-activity-dashbard.component';
import { LogTypeBenchmarksComponent } from './admin/system-reports/benchmarks/log-type-benchmarks/log-type-benchmarks.component';
import { LogTypeBenchmarkCreateComponent } from './admin/system-reports/benchmarks/log-type-benchmark-create/log-type-benchmark-create.component';
import { LogTypeBenchmarkUpdateComponent } from './admin/system-reports/benchmarks/log-type-benchmark-update/log-type-benchmark-update.component';
import { LogTypeBenchmarkComponent } from './admin/system-reports/benchmarks/log-type-benchmark/log-type-benchmark.component';
import { StaffPerformanceMetricsTreeGridStaffComponent } from './admin/system-reports/staff-performance-metrics/staff-performance-metrics-tree-grid-staff/staff-performance-metrics-tree-grid-staff.component';
import { MetricChartMultiSeriesStaffComponent } from './admin/system-reports/staff-performance-metrics/metric-chart-multi-series-staff/metric-chart-multi-series-staff.component';
import { MetricChartMultiSeriesStaffDataComponent } from './admin/system-reports/staff-performance-metrics/metric-chart-multi-series-staff-data/metric-chart-multi-series-staff-data.component';
import { MetricCharDataExamplesComponent } from './admin/system-reports/staff-performance-metrics/metric-char-data-examples/metric-char-data-examples.component';
import { StaffPerformanceMetricsDashboardComponent } from './admin/system-reports/staff-performance-metrics/staff-performance-metrics-dashboard/staff-performance-metrics-dashboard.component';
import { MetricChartMultiSeriesStaffAllComponent } from './admin/system-reports/staff-performance-metrics/metric-chart-multi-series-staff-all/metric-chart-multi-series-staff-all.component';
import { MetricChartMultiSeriesStaffAllLineComponent } from './admin/system-reports/staff-performance-metrics/metric-chart-multi-series-staff-all-line/metric-chart-multi-series-staff-all-line.component';
import { MetricChartMultiSeriesStaffUserMultipleAxisComponent } from './admin/system-reports/staff-performance-metrics/metric-chart-multi-series-staff-user-multiple-axis/metric-chart-multi-series-staff-user-multiple-axis.component';
import { BenchmarkpiGroupsComponent } from './admin/system-reports/benchmarks/benchmarkpi-groups/benchmarkpi-groups.component';
import { BenchmarkpiGroupUpdateComponent } from './admin/system-reports/benchmarks/benchmarkpi-group-update/benchmarkpi-group-update.component';
import { BenchmarkpiGroupViewComponent } from './admin/system-reports/benchmarks/benchmarkpi-group-view/benchmarkpi-group-view.component';
import { SystemLogTypesBenchmarksTreeGridComponent } from './admin/system-settings/system-log-types-benchmarks-tree-grid/system-log-types-benchmarks-tree-grid.component';
import { MetricChartMultiSeriesStaffSingleComponent } from './admin/system-reports/staff-performance-metrics/metric-chart-multi-series-staff-single/metric-chart-multi-series-staff-single.component';
import { StaffPerformanceMetricsSavedDashboardComponent } from './admin/system-reports/staff-performance-metrics/staff-performance-metrics-saved-dashboard/staff-performance-metrics-saved-dashboard.component';
import { AgentPerformanceMetricsDashboardComponent } from './admin/system-reports/agent-performance-metrics/agent-performance-metrics-dashboard/agent-performance-metrics-dashboard.component';
import { AgentPerformanceMetricsSavedDashboardComponent } from './admin/system-reports/agent-performance-metrics/agent-performance-metrics-saved-dashboard/agent-performance-metrics-saved-dashboard.component';
import { ClientPerformanceMetricsComponent } from './admin/system-reports/client-performance-metrics/client-performance-metrics.component';
import { ClientPerformanceMetricsSavedDashboardComponent } from './admin/system-reports/client-performance-metrics/client-performance-metrics-saved-dashboard/client-performance-metrics-saved-dashboard.component';
import { AgentPerformanceMetricsAttemptsDashboardComponent } from './admin/system-reports/agent-performance-metrics/agent-performance-metrics-attempts-dashboard/agent-performance-metrics-attempts-dashboard.component';
import { AgentPerformanceMetricsAttemptsGridTreeComponent } from './admin/system-reports/agent-performance-metrics/agent-performance-metrics-attempts-grid-tree/agent-performance-metrics-attempts-grid-tree.component';
import { MetricChartMulitiSeriesAgentAttemptsAllComponent } from './admin/system-reports/agent-performance-metrics/metric-chart-muliti-series-agent-attempts-all/metric-chart-muliti-series-agent-attempts-all.component';
import { AgentPerformanceMetricsAttemptBenchmarksComponent } from './admin/system-reports/agent-performance-metrics/agent-performance-metrics-attempt-benchmarks/agent-performance-metrics-attempt-benchmarks.component';
import { AgentPerformanceMetricsAttemptBenchmarkUpdateComponent } from './admin/system-reports/agent-performance-metrics/agent-performance-metrics-attempt-benchmark-update/agent-performance-metrics-attempt-benchmark-update.component';
import { MeticsChartMultiSeriesAgentAttemptsSingleComponent } from './admin/system-reports/agent-performance-metrics/metics-chart-multi-series-agent-attempts-single/metics-chart-multi-series-agent-attempts-single.component';
import { DbeRestAdminComponent } from './admin/system-settings/dbe-rest-admin/dbe-rest-admin.component';
import { DbeRestReportComponent } from './admin/system-settings/dbe-rest-report/dbe-rest-report.component';
import { ClientApiOnboardingComponent } from './admin/system-settings/client-api-onboarding/client-api-onboarding.component';
import { SystemNoticesComponent } from './admin/system-notices/system-notices/system-notices.component';
import { SystemNoticeBannerComponent } from './admin/system-notices/system-notice-banner/system-notice-banner.component';
import { SystemNoticeCreateComponent } from './admin/system-notices/system-notice-create/system-notice-create.component';
import { SystemNoticeUpdateComponent } from './admin/system-notices/system-notice-update/system-notice-update.component';
import { NoticeStatusPipe } from './pipes/notice-status.pipe';
import { TimeframeSurchargesComponent } from './admin/system-settings/timeframe-surcharges/timeframe-surcharges.component';
import { TimeframeSurchargeUpdateComponent } from './admin/system-settings/timeframe-surcharge-update/timeframe-surcharge-update.component';
import { TimeframeSurchargeCreateComponent } from './admin/system-settings/timeframe-surcharge-create/timeframe-surcharge-create.component';
import { TimeframeSurchargeDetailsWidgetComponent } from './admin/system-settings/timeframe-surcharge-details-widget/timeframe-surcharge-details-widget.component';
import { JobsUrgentTimeframesComponent } from './admin/jobs/jobs-urgent-timeframes/jobs-urgent-timeframes.component';
import { SubjectsUrgentExportJobSchedulesComponent } from './admin/system-reports/subjects-urgent-export-job-schedules/subjects-urgent-export-job-schedules.component';
import { SubjectsUrgentExportJobScheduleCreateComponent } from './admin/system-reports/subjects-urgent-export-job-schedule-create/subjects-urgent-export-job-schedule-create.component';
import { SubjectsUrgentExportJobScheduleUpdateComponent } from './admin/system-reports/subjects-urgent-export-job-schedule-update/subjects-urgent-export-job-schedule-update.component';
import { SubjectsUrgentExportJobScheduleComponent } from './admin/system-reports/subjects-urgent-export-job-schedule/subjects-urgent-export-job-schedule.component';
import { ClientJobsUrgentTimeframesComponent } from './client/client-jobs-urgent-timeframes/client-jobs-urgent-timeframes.component';
import { AgentJobsUrgentTimeframesComponent } from './agent/agent/agent-jobs-urgent-timeframes/agent-jobs-urgent-timeframes.component';
import { JobCreateFormSubjectAdditionsComponent } from './components/jobs/job-create-form-subject-additions/job-create-form-subject-additions.component';
import { DynamicFieldRenderComponent } from './components/jobs/job-create-form-subject-additions/dynamic-field-render/dynamic-field-render.component';
import { SubjectServiceResolutionOutcomesComponent } from './admin/system-settings/subject-service-resolution-outcomes/subject-service-resolution-outcomes.component';
import { SubjectAttemptResolutionOutcomesQuickRateWidgetComponent } from './components/jobs/subject-attempt-resolution-outcomes-quick-rate-widget/subject-attempt-resolution-outcomes-quick-rate-widget.component';
import { AgentPerformanceActivityMetricsAttemptBenchmarksComponent } from './admin/system-reports/agent-performance-activity-metrics/agent-performance-activity-metrics-attempt-benchmarks/agent-performance-activity-metrics-attempt-benchmarks.component';
import { AgentPerformanceActivityMetricsAttemptAttemptsComponent } from './admin/system-reports/agent-performance-activity-metrics/agent-performance-activity-metrics-attempt-attempts/agent-performance-activity-metrics-attempt-attempts.component';
import { AgentPerformanceActivityMetricsAttemptsComponent } from './admin/system-reports/agent-performance-activity-metrics/agent-performance-activity-metrics-attempts/agent-performance-activity-metrics-attempts.component';
import { AgentPerformanceActivityMetricsProgressComponent } from './admin/system-reports/agent-performance-activity-metrics/agent-performance-activity-metrics-progress/agent-performance-activity-metrics-progress.component';
import { AgentPerformanceActivityMetricsAttemptsIndexedComponent } from './admin/system-reports/agent-performance-activity-metrics/agent-performance-activity-metrics-attempts-indexed/agent-performance-activity-metrics-attempts-indexed.component';
import { AgentPerformanceActivityMetricsDashboardIndexedComponent } from './admin/system-reports/agent-performance-activity-metrics/agent-performance-activity-metrics-dashboard-indexed/agent-performance-activity-metrics-dashboard-indexed.component';
import { AgentPerformanceActivityMetricsSummaryWidgetComponent } from './admin/system-reports/agent-performance-activity-metrics/agent-performance-activity-metrics-summary-widget/agent-performance-activity-metrics-summary-widget.component';
import { AgentPerformanceActivityMetricsMetricGroupsWidgetComponent } from './admin/system-reports/agent-performance-activity-metrics/agent-performance-activity-metrics-metric-groups-widget/agent-performance-activity-metrics-metric-groups-widget.component';
import { AgentPerformanceActivityMetricsSelectedMetricAuditWidgetComponent } from './admin/system-reports/agent-performance-activity-metrics/agent-performance-activity-metrics-selected-metric-audit-widget/agent-performance-activity-metrics-selected-metric-audit-widget.component';
import { AgentPerformanceActivityMetricsFixedPointProvenanceWidgetComponent } from './admin/system-reports/agent-performance-activity-metrics/agent-performance-activity-metrics-fixed-point-provenance-widget/agent-performance-activity-metrics-fixed-point-provenance-widget.component';
import { AgentPerformanceActivityMetricsAuditOverviewWidgetComponent } from './admin/system-reports/agent-performance-activity-metrics/agent-performance-activity-metrics-audit-overview-widget/agent-performance-activity-metrics-audit-overview-widget.component';
import { AgentPerformanceActivityMetricsTechnicalOverviewWidgetComponent } from './admin/system-reports/agent-performance-activity-metrics/agent-performance-activity-metrics-technical-overview-widget/agent-performance-activity-metrics-technical-overview-widget.component';
import { AgentPerformanceActivityMetricsAuditReviewWidgetComponent } from './admin/system-reports/agent-performance-activity-metrics/agent-performance-activity-metrics-audit-review-widget/agent-performance-activity-metrics-audit-review-widget.component';
import { AgentPerformanceActivityMetricsDiagnosticsTailWidgetComponent } from './admin/system-reports/agent-performance-activity-metrics/agent-performance-activity-metrics-diagnostics-tail-widget/agent-performance-activity-metrics-diagnostics-tail-widget.component';
import { AgentPerformanceActivityMetricsBreakdownGroupsWidgetComponent } from './admin/system-reports/agent-performance-activity-metrics/agent-performance-activity-metrics-breakdown-groups-widget/agent-performance-activity-metrics-breakdown-groups-widget.component';
import { AgentPerformanceActivityMetricsContextPanelComponent } from './admin/system-reports/agent-performance-activity-metrics/agent-performance-activity-metrics-context-panel/agent-performance-activity-metrics-context-panel.component';
import { SubjectServiceResolutionOutcomeTypeSelectorComponent } from './admin/system-settings/subject-service-resolution-outcomes/subject-service-resolution-outcome-type-selector.component';
import { SubjectServiceResolutionOutcomeTypeModalComponent } from './admin/system-settings/subject-service-resolution-outcome-type-modal/subject-service-resolution-outcome-type-modal.component';
// import { TreeMapModule } from '@syncfusion/ej2-angular-treemap';
// import { TreeViewModule } from '@syncfusion/ej2-angular-navigations';
// import { DiagramModule, OverviewModule, SymbolPalette, SymbolPaletteAllModule, SymbolPaletteComponent, SymbolPaletteModule } from '@syncfusion/ej2-angular-diagrams';

import { BenchmarkMinutesComponent } from './shared/benchmark-minutes/benchmark-minutes.component';
import { StaffWeightedWorkComponent } from './admin/system-reports/staff-performance-metrics/weighted-work/staff-weighted-work.component';
import { StaffWeightedWorkLiveComponent } from './admin/system-reports/staff-performance-metrics/weighted-work/staff-weighted-work-live.component';

import { StaffAchievementComponent } from './admin/system-reports/staff-performance-metrics/achievements/staff-achievement.component';
import { StaffAchievementLiveComponent } from './admin/system-reports/staff-performance-metrics/achievements/staff-achievement-live.component';

@NgModule({
  declarations: [
    BenchmarkMinutesComponent, StaffWeightedWorkComponent, StaffWeightedWorkLiveComponent,
    StaffAchievementComponent, StaffAchievementLiveComponent,
    AppComponent,
    HomeComponent,
    LoginComponent,
    AdminComponent,
    TxcPrototypeComponent,
    LogoutComponent,
    ExampleTextControlComponent,
    JobsHomeComponent,
    TxcSimpleNavComponent,
    CommunicationComponent,
    JobsDashboardComponent,
    JobSubjectSearchWidgetComponent,
    JobsComponent,
    JobsGridComponent,
    JobViewComponent,
    JobDetailsWidgetComponent,
    JobSubjectDocumentAddWidgetComponent,
    JobsFileGridComponent, // layoyts
    DateAgoPipe,
    AuditDatePipe,
    AuditDateAgoPipe,
    AuditDateComparePipe,
    LegalDatePipe,
    LegalDateComparePipe,
    AssignSystemFileWidgetComponent,
    MultiSelectDropdownComponent,
    JobFileUploadWidgetComponent,
    SubjectNotesListComponent,
    JobsSubjectsNotesGridComponent,
    JobsSubjectsGridComponent,
    SubjectCardComponent,
    SubjectNavBarComponent,
    SubjectCardComponent,
    SubjectDetailsEditWidgetComponent,
    AutocompleteComponentComponent,
    SubjectContactNumberAddWidgetComponent,
    SubjectContactEmailEditWidgetComponent,
    SubjectContactEmailAddWidgetComponent,
    SubjectAgentBrandsComponent,
    SubjectJobTypeChangeComponent,
    SubjectStatusChangeComponent,
    SubjectCloseComponent,
    SendEmailWidgetComponent,
    AddCommunicationEmailRecipientWidgetComponent,
    SubjectDeleteWidgetComponent,
    SubjectContactNumberEditWidgetComponent,
    JobSubjectAttemptsGridComponent,
    SubjectAttemptEditWidgetComponent,
    SubjectAttemptDetailsWidgetComponent,

    SubjectDetailsWidgetComponent,
    SubjectDocumentsComponent,
    SubjectDocumentsCreateDocxMergeWidgetComponent,
    EditDocxSystemFileComponent, // new editor txc
    CommunicationManagerComponent, // Communication Manager
    SubjectComTypeViewComponent,
    UploadDocxThemeTemplateComponent,
    SubjectComTypeEditComponent,
    SubjectComTypeTemplateDocViewComponent,
    SubjectComTypeTemplateDocEditComponent,
    UploadDocxTemplateModalComponent,
    UploadEmailTemplateModalComponent,
    UploadDotTemplateModalComponent,
    SubjectComTypeTemplateDocCreateComponent,
    EditDocxTemplateFileComponent,
    TxcMailMergeComponent,
    UserDetailsWidgetComponent,
    LostPasswordComponent,
    PasswordStrengthWidgetComponent,
    UserAvitarModalUploadComponent,
    UserPasswordExpiredModalComponent,
    UserDetailsWidgetComponent,
    UserPasswordWidgetComponent,
    JobsUrgentComponent,
    NotesGridComponent,
    JobsClosedComponent,
    CreateJobComponent,
    BrandCreateWidgetComponent,
    FileUploadsModalComponent,
    CreateJob2Component,
    JobPlaintiffAddWidgetComponent,
    CreateJob3Component,
    JobDetailsEditWidgetComponent,
    JobReportSubjectAddWidgetComponent,
    EditJobComponent,
    JobDetailsEditWidgetComponent,
    SubjectCommunicationComponent,
    CompaniesHomeComponent,
    CompanyViewComponent,
    CompanyEditComponent,
    MyobApiCustomerClientSyncToolsWidgetComponent,
    MyobApiCustomerSupplierSyncToolsWidgetComponent,
    CompanyDeleteWidgetComponent,
    UsersListComponent,
    FileUploadsModalComponent,
    JobFileUploadWidgetComponent,
    UserViewComponent,
    DeleteUserWidgetComponent,
    UserEditComponent,
    UserCreateComponent,
    CompanyCreateComponent,
    SystemFileManagerComponent,
    SystemFileViewComponent,
    FileDetailsWidgetComponent,
    SystemFileEditComponent,
    SystemDocEditComponent,
    ViewDocxSystemFileComponent,
    SystemCommunicationHistoryComponent,
    SystemNoteManagerComponent,
    DocxThemeTemplateGridComponent,
    JobsSubjectsCreatedReportComponent,
    AgentPerformanceMetricsComponent,
    SubjectAttemptDetailsWidgetComponent,
    StaffPerformanceMetricsComponent,
    NewSystemContactsReportComponent,
    SystemLogManagerComponent,
    SystemSettingsComponent,
    SystemJobTypesComponent,
    UpdateTypesComponent,
    CreateTypesComponent,
    CreateJobTypeComponent,
    SystemJobTypeLocationsComponent,
    UpdateLocationComponent,
    CreateLocationComponent,
    SystemLocationCourtsComponent,
    UpdateCourtComponent,
    CreateCourtComponent,
    SystemCourtDocumentTypesComponent,
    UpdateDocumentComponent,
    CreateDocumentComponent,
    SystemDocumentTypeAffidavitsComponent,
    SystemJobTypesBreadcrumbsComponent,
    UpdateAffidavitComponent,
    CreateAffidavitComponent,
    CreateSubjectComTypeTemplateFromAffidavitModalComponent,
    SystemJobServiceRulesComponent,
    UpdateServiceRuleComponent,
    CreateServiceRuleComponent,
    SystemJobServiceTimeframesComponent,
    UpdateServiceTimeframeComponent,
    CreateServiceTimeframeComponent,
    SystemSubjectServiceTypesComponent,
    UpdateSubjectServiceTypeComponent,
    CreateSubjectServiceTypeComponent,
    AccountingBillingTasksComponent,
    EditBillingTaskWidgetComponent,
    CreateBillingTaskWidgetComponent,
    AccountingCostTasksComponent,
    EditCostTaskWidgetComponent,
    CreateCostTaskWidgetComponent,
    AccountingMyobAccountCodesComponent,
    MyobAccountCodesLiveGridComponent,
    MyobAccountCodesGridComponent,
    AccountingMyobTaxCodesComponent,
    MyobTaxCodesLiveGridComponent,
    MyobTaxCodesGridComponent,
    SubjectDetailsEditWidgetComponent,
    SubjectAgentBrandsComponent,
    SubjectBillingTabComponent,
    SubjectBillingComponent,
    ClientInvoiceBulkPaymentWidgetComponent,
    MyobApiInvoicePaymentSyncToolsWidgetComponent,
    MyobApiInvoiceSyncToolsWidgetComponent,
    MyobApiInvoicePaymentSyncToolsWidgetComponent,
    BrandInvoicesGridComponent,
    UpdateInvoiceWidgetComponent,
    InvoicePdfFileListWidgetComponent,
    CreateInvoicePaymentWidgetComponent,
    InvoicePaymentWidgetComponent,
    UpdateInvoicePaymentWidgetComponent,
    SubjectBillingItemsGridComponent,
    CreateInvoiceWidgetComponent,
    InvoiceItemRowFormWidgetComponent,
    // AddSubjectBillingItemWidgetComponent, // layouts
    InvoiceStatusChangeWidgetComponent,
    InvoicePaymentStatusChangeWidgetComponent,
    InvoiceCommunicationStatusChangeWidgetComponent,
    InvoiceLogWidgetComponent,
    AddSubjectCostItemWidgetComponent,
    CreateWorkOrderWidgetComponent,
    SubjectCostTabComponent,
    SubjectCostComponent,
    SubjectAgentCostWidgetComponent,
    MyobApiPurchaseSyncToolsWidgetComponent,
    WorkOrdersGridComponent,
    UpdateWorkOrderWidgetComponent,
    WorkOrderStatusChangeWidgetComponent,
    WorkOrderPaymentStatusChangeWidgetComponent,
    WorkOrderCommunicationStatusChangeWidgetComponent,
    WorkOrderItemRowFormWidgetComponent,
    CreateWorkOrderPaymentWidgetComponent,
    WorkOrderPaymentWidgetComponent,
    MyobApiPurchasePaymentSyncToolsWidgetComponent,
    WorkOrderBulkPaymentWidgetComponent,
    BrandWorkOrdersGridComponent,
    SubjectCostItemsGridComponent,
    InvoicesComponent,
    InvoicesGridComponent,
    MyobServiceInvoicesGridComponent,
    ClientOutstandingsComponent,
    PaymentsBulkComponent,
    MyobCustomersComponent,
    MyobCustomersGridComponent,
    PaymentsComponent,
    PaymentsGridComponent,
    MyobPaymentsGridComponent,
    InvoicesSuppliersComponent,
    MyobServiceWorkOrdersGridComponent,
    AgentOutstandingsComponent,
    PaymentsBulkSupplierComponent,
    MyobSuppliersComponent,
    MyobSuppliersGridComponent,
    MyobPaymentsSuppliersComponent,
    WorkOrderPaymentsGridComponent,
    MyobPurchasePaymentsGridComponent,
    MyobLoginComponent,
    JobFileUploadWidget2Component,
    DropzoneDirective,
    JobFileUploadWidget3Component,
    EditDocxThemeFileComponent,
    SubjectComTypeCreateComponent,
    JobDeleteWidgetComponent,
    ReportNewAgentContactsComponent,
    UploadProgressComponent,
    //staff
    StaffComponent,
    StaffDashboardComponent,
    UserDetailsWidgetComponent,
    CreateJobStatusComponent,
    SubjectNotesTabComponent,
    // Client
    ClientComponent,
    ClientDashboardComponent,
    ClientJobsComponent,
    ClientJobCreateComponent,
    ClientJobCreate2Component,
    ClientJobCreate3Component,
    ClientJobViewComponent,
    ClientJobSubjectComponent,
    ClientProfileComponent,
    BrandDetailsWidgetComponent,
    ClientApiAccessWidgetComponent,
    ClientProfileEditComponent,
    BrandDetailsEditWidgetComponent,
    ClientUserProfileComponent,
    UserDetailsWidgetComponent,
    UserDetailsEditWidgetComponent,
    ClientUserProfileEditComponent,
    ClientUsersComponent,
    UsersGridComponent,
    // Agent
    AgentComponent,
    AgentJobsComponent,
    AgentViewSubjectComponent,
    SubjectAttendenceComponent,
    UserProfileDisplayComponent,
    AgentJobViewComponent,
    AgentJobSubjectComponent,
    AgentProfileComponent,
    AgentProfileEditComponent,
    AgentUserProfileComponent,
    AgentUserProfileEditComponent,
    AgentUsersComponent,
    SubjectServiceComponent,
    SubjectServiceListComponent, 
    SubjectCardComponent, DocxInUseCheckWidgetComponent, AssignSystemNoteWidgetComponent, NoteDetailsWidgetComponent, CreateAffidavitWidgetComponent, JobFileUploadWidget3AttemptsComponent, JobsFileAttachedWidgetComponent, MyobServiceInvoiceComparitorComponent, MyobDailyTasksComponent, UpdateWorkOrderPaymentWidgetComponent, ClientInvoicesComponent, AgentInvoicesComponent, ClientJobCreateWizardStep1Component, ClientJobCreateWizardStep2Component, JobDetailsEditWidgetClientComponent, ClientJobCreateWizardStep3Component, ClientJobsUrgentComponent, ClientJobStatusKeyWidgetComponent, UpdateJobStatusWidgetComponent, BrandGlobalCompanyKeyWidgetComponent, SystemInvestigationComponent, SystemActionListsComponent, SystemActionListComponent, ActionListWidgetComponent, SystemLogCountWidgetComponent, SystemLogViewComponent, SystemLogViewWidgetComponent, SystemLogTypesComponent, UpdateSystemLogTypeComponent, SystemAutomationsComponent, SystemAutomationCreateComponent, CreateSystemLogTypeComponent, SystemAutomationUpdateComponent, SystemAutomationComponent, 
    // SystemForceLogoutWidgetComponent,
    VariableCodeBlocksComponent,
VariableCodeBlocksGridComponent,
VariableCodeBlockCreateComponent,
VariableCodeBlockCreateWidgetComponent,
VariableCodeBlockUpdateWidgetComponent,
VariableCodeBlockUpdateComponent,
WooPromotionVariableModalComponent,
HtmlEditorModalWidgetComponent,
SystemLogTypeDataSectorConditionsComponent,
SystemLogTypeDataSectorConditionUpdateComponent,
SystemLogTypeDataSectorConditionCreateComponent,
SystemLogTypeDataSectorConditionComponent,
SystemLogTypeDataSectorsComponent,
SystemLogTypeDataSectorComponent,
SystemLogTypeDataSectorCreateComponent,
SystemLogTypeDataSectorUpdateComponent,
SystemLogTypeComponent,
SystemLogTypeDataSectorTypesComponent,
SystemLogTypeDataSectorTypeComponent,
SystemLogTypeDataSectorTypeCreateComponent,
SystemLogTypeDataSectorTypeUpdateComponent,
SystemLogTypeDataSSystemLogTypeDataSectorConditionComponent,
AttemptGridDateLocalWidgetComponent,
SubjectServiceOutcomeTemplatesComponent,
SubjectServiceOutcomeTemplateCreateComponent,
SubjectServiceOutcomeTemplateComponent,
SubjectServiceOutcomeTemplateUpdateComponent,
AppRoutesComponent,
// AppRoutesGridComponent,
//Routes
  // AppRoutesComponent,
  AppRouteCreateComponent,
  AppRouteUpdateComponent,
  // AppRoutesGridComponent,
  // AppRouteUpdateWidgetComponent, // -- in layouts
  // AppRouteCreateWidgetComponent, // -- in layouts module/
  AppRouteComponent,

  // AppRoutesGridTreeComponent,
  // AppRoutesDiagramComponent,
  // AppRoutesTreeMapComponent,
  // AppRoutesTreeListComponent,
  // AppRoutesDiagramHierarchialComponent,
   ProjectsHomeComponent,
   ProjectsGridComponent,
   EditJobProjectWizardComponent,
   CreateJobProjectWidgetComponent,
   ProjectsEditComponent,
   ProjectAdminViewComponent,
   SubjectCommunicationWithVarsComponent,
   ViewCommunicationHistoryWidgetComponent,
   SubjectUrgentOutcomeTemplatesComponent,
   SubjectUrgentOutcomeTemplateUpdateComponent,
   SubjectUrgentOutcomeTemplateCreateComponent,
   SubjectUrgentOutcomeTemplateComponent,
   SystemLogWidgetComponent,
   JobsSubjectsTimelineGridComponent,
   HighlighterPipe,
   NoteEditWidgetComponent,
   MyobPaymentsGridInvoiceComponent,
   PaymentsGridInvoiceComponent,
   MyobServiceInvoicesGridInvoiceComponent,
   MyobCustomersGridBrandComponent,
   MyobServiceWorkOrdersGridWorkOrderComponent,
   WorkOrderPaymentsGridWorkOrderComponent,
   WorkOrderLogWidgetComponent,
   SubjectServiceMultipleWidgetComponent,
   SubjectCardLayoutsDashboardComponent,
   QuicklinksMenusWidgetComponent,
   SubjectActivityLogWidgetComponent,
   SubjectActivityLogGraphWidgetComponent,
   Login2FAComponent,
   LoginEnterCodeTFAComponent,
   LoginUserSetupTFAComponent,
   FormatFileSizePipe,
   JobsGridTreeComponent,
   JobsSortingComponent,
   JobsGridSortingComponent,
   SystemActivityDashbardComponent,
   LogTypeBenchmarksComponent,
   LogTypeBenchmarkCreateComponent,
   LogTypeBenchmarkUpdateComponent,
   LogTypeBenchmarkComponent,
   StaffPerformanceMetricsTreeGridStaffComponent,
   MetricChartMultiSeriesStaffComponent,
   MetricChartMultiSeriesStaffDataComponent,
   MetricCharDataExamplesComponent,
   StaffPerformanceMetricsDashboardComponent,
   MetricChartMultiSeriesStaffAllComponent,
   MetricChartMultiSeriesStaffAllLineComponent,
   MetricChartMultiSeriesStaffUserMultipleAxisComponent,
   BenchmarkpiGroupsComponent,
   BenchmarkpiGroupUpdateComponent,
   BenchmarkpiGroupViewComponent,
   SystemLogTypesBenchmarksTreeGridComponent,
   MetricChartMultiSeriesStaffSingleComponent,

   StaffPerformanceMetricsSavedDashboardComponent,
    AgentPerformanceMetricsDashboardComponent,
    AgentPerformanceMetricsSavedDashboardComponent,
    ClientPerformanceMetricsComponent,
    ClientPerformanceMetricsSavedDashboardComponent,
    AgentPerformanceMetricsAttemptsDashboardComponent,
    AgentPerformanceMetricsAttemptsGridTreeComponent,
    MetricChartMulitiSeriesAgentAttemptsAllComponent,
    AgentPerformanceMetricsAttemptBenchmarksComponent,
    AgentPerformanceMetricsAttemptBenchmarkUpdateComponent,
    MeticsChartMultiSeriesAgentAttemptsSingleComponent,
    DbeRestAdminComponent,
    DbeRestReportComponent,
    ClientApiOnboardingComponent,
    SystemNoticesComponent,
    // SystemNoticeBannerComponent,
    SystemNoticeCreateComponent,
    SystemNoticeUpdateComponent,
    NoticeStatusPipe,
    TimeframeSurchargesComponent,
    TimeframeSurchargeUpdateComponent,
    TimeframeSurchargeCreateComponent,
    TimeframeSurchargeDetailsWidgetComponent,
    JobsUrgentTimeframesComponent,
    SubjectsUrgentExportJobSchedulesComponent,
    SubjectsUrgentExportJobScheduleCreateComponent,
    SubjectsUrgentExportJobScheduleUpdateComponent,
    SubjectsUrgentExportJobScheduleComponent,
    ClientJobsUrgentTimeframesComponent,
    AgentJobsUrgentTimeframesComponent,
    JobCreateFormSubjectAdditionsComponent,
    DynamicFieldRenderComponent,
    SubjectServiceResolutionOutcomesComponent,
  
    SubjectAttemptResolutionOutcomesQuickRateWidgetComponent,
       AgentPerformanceActivityMetricsAttemptBenchmarksComponent,
       AgentPerformanceActivityMetricsAttemptAttemptsComponent,
       AgentPerformanceActivityMetricsAttemptsComponent,
       AgentPerformanceActivityMetricsAttemptsIndexedComponent,
       AgentPerformanceActivityMetricsDashboardIndexedComponent,
       AgentPerformanceActivityMetricsProgressComponent,
       AgentPerformanceActivityMetricsSummaryWidgetComponent,
       AgentPerformanceActivityMetricsMetricGroupsWidgetComponent,
       AgentPerformanceActivityMetricsSelectedMetricAuditWidgetComponent,
       AgentPerformanceActivityMetricsFixedPointProvenanceWidgetComponent,
       AgentPerformanceActivityMetricsAuditOverviewWidgetComponent,
       AgentPerformanceActivityMetricsTechnicalOverviewWidgetComponent,
       AgentPerformanceActivityMetricsAuditReviewWidgetComponent,
       AgentPerformanceActivityMetricsDiagnosticsTailWidgetComponent,
       AgentPerformanceActivityMetricsBreakdownGroupsWidgetComponent,
       AgentPerformanceActivityMetricsContextPanelComponent,
       SubjectServiceResolutionOutcomeTypeSelectorComponent,
       SubjectServiceResolutionOutcomeTypeModalComponent,
  //  ScrollTopComponent, // layouts
  //  UnderTheHoodWidgetComponent,
  //  AppRoutesDiagramKanBanComponent,
  //  AppRoutesDiagramKanBanSearchComponent,
  //  AppRoutesDiagramKanPanDataComponentComponent,
   
  //  AppRoutesDiagramKanPanDataComponentComponent,
  //  AppRouteBillingItemUpdateComponent, // layouts

  // AppRoutesDiagramHierarchialComplexComponent,
  // AppRoutesDiagramLocalDataComponent,
  // AppRoutesDiagramOnInitComponent,
  // AppRoutesDiagramUsersComponent,
  // AppRoutesDiagramOverViewComponent,
  // AppRoutesDiagramRadialTreeComponent,
  // AppRoutesDiagramAppNetworkComponent,
  // AppRoutesDiagramKanBanComponent,
  // AppRoutesDiagramKanPanDataComponent,
  // AppRoutesDiagramProposalComponent,

  ],
  imports: [
    BrowserModule,
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    // RouterModule.forRoot([
    //   { path: 'mailmerge', component: TxcMailMergeComponent, pathMatch: 'full' },
    // ], {useHash: true}),
    AppRoutingModule,
    DocumentEditorModule,
    DocumentViewerModule,
    FormsModule,
    HttpClientModule,
    LayoutsModule,
    RouterModule.forRoot(routes, {useHash: true,
      // added for hashtags anchor and fragnebt scolling.
      anchorScrolling: 'enabled',
      onSameUrlNavigation: 'reload',
      scrollPositionRestoration: 'enabled'

    }),

    SplitterModule, NgTemplateOutlet,ChipListModule,
    
    TabsModule.forRoot(),
    AlertModule.forRoot(),
    // ToastModule.forRoot(),
   // ModalDialogModule.forRoot(),
    ModalModule.forRoot(),
    BsDatepickerModule.forRoot(),
    BsDropdownModule.forRoot(),
    PaginationModule.forRoot(),
    IboxtoolsModule,
    AlertModule,
    // TabsModule,
    // new taoster - hotToast
    HotToastModule.forRoot(),
        // Registering EJ2 Button Module
 ButtonModule,
 GridModule,
 MenuModule,
 BrowserModule,
   // Registering EJ2 filemanager Module
   RichTextEditorModule,
   MultiSelectModule,
   DatePickerModule,
   DateTimePickerAllModule,
   DialogModule,
   DropDownListModule,
   ComboBoxModule,
   AutoCompleteModule,
   // TreeViewModule,
   AccordionModule,
   ListBoxModule,
   // ChartModule,
  // DocumentEditorModule,
  // DocumentEditorContainerModule,
  ReactiveFormsModule,
  NgxPaginationModule,
  HttpClientModule,
  NgMultiSelectDropDownModule.forRoot(),
  MaterialModule,
  NgxFileDropModule,
 TimepickerModule.forRoot(),
 SortableModule.forRoot(),
//  FileDropModule,
//  ngfModule,
ChartModule,
SliderModule,
QRCodeModule,
CodemirrorModule,
DashboardLayoutModule,
  TreeGridModule,
  // // TreeMapModule,
  // TreeViewModule,
  // DiagramModule,
  // BrowserModule, 
// DiagramModule,
//  OverviewModule, 
//  ToolbarModule,
//  SymbolPaletteAllModule,
  // SymbolPaletteModule, 
  // UploaderAllModule, 
  // UploaderModule,
   KanbanModule, 
 TreeViewModule,
 AccumulationChartAllModule,
 ListBoxAllModule,
 BulletChartModule,

  ],
  exports:[
  FormsModule,
  RouterModule, AppRoutingModule, TabsModule,
  DiagramModule,
  AddSubjectBillingItemWidgetComponent,
  
  ],
  providers: [
    {provide: LocationStrategy, useClass: HashLocationStrategy},
    AuthenticationService, GlobalFunctionsService, MysqlService, DemoService, AuthGuard, IdleService, AdminGuard, StaffGuard, ClientGuard, AgentGuard, DatePipe, BsModalService, BsModalRef ,
    MyobApiInvoicePaymentSyncToolsWidgetComponent, MyobApiCustomerClientSyncToolsWidgetComponent, MyobApiInvoiceSyncToolsWidgetComponent,
    ClientInvoiceBulkPaymentWidgetComponent, ClientInvoiceBulkPaymentWidgetComponent,
    BrandInvoicesGridComponent, BrandWorkOrdersGridComponent, WorkOrderBulkPaymentWidgetComponent,MyobApiPurchasePaymentSyncToolsWidgetComponent,
    ToolbarService,
    LinkService,
    ImageService,
    HtmlEditorService,
    MultiSelectComponent,
    DropDownListComponent,
    SearchService,
    GridModule,
    FileUploaderService, 
    TabsetComponent,
    MyobApiCustomerSupplierSyncToolsWidgetComponent,
    MyobApiPurchaseSyncToolsWidgetComponent,
    WorkOrdersGridComponent,
 

    {
        provide: HTTP_INTERCEPTORS,
        useClass: JwtInterceptor,
        multi: true
    },
  
    PageService, ToolbarService, SortService, FilterService, GroupService, FreezeService, SelectionService, ResizeService,
    ToolbarService, ExcelExportService, PdfExportService, DecimalPipe,
         // :: Node JS Services Provider
         UserService2, MyobContactService,
         // Syncfusin DIagram
HierarchicalTreeService, MindMapService, RadialTreeService, ComplexHierarchicalTreeService, DataBindingService, SnappingService, PrintAndExportService, BpmnDiagramsService, SymmetricLayoutService, ConnectorBridgingService, UndoRedoService, LayoutAnimationService, DiagramContextMenuService, ConnectorEditingService,
EditService, ToolbarService, PageService, FilterService, SortService
  ],
  bootstrap: [AppComponent],



// SubjectEditComponent,
// SubjectServiceComponent
  entryComponents: [ SubjectServiceListComponent, SubjectAttemptEditWidgetComponent,
    UserAvitarModalUploadComponent, UploadDocxTemplateModalComponent, UploadEmailTemplateModalComponent, UploadDotTemplateModalComponent, 
    UploadDocxThemeTemplateComponent, UserPasswordExpiredModalComponent, FileUploadsModalComponent, 
    ], // for models to components to work

  })
export class AppModule { }
